import store from '@/store'

export function showMsg(text, color = 'error') {

    store.dispatch('snackbar/show', {
        text,
        color
    })
}
